var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page-heading"},[(_vm.breadcrumbs)?_c('Breadcrumbs',{staticClass:"page-heading__breadcrumbs",attrs:{"items":_vm.breadcrumbs}}):_vm._e(),_c('h1',{staticClass:"page-heading__title"},[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }